import React from 'react';

import { useNavigate } from 'react-router-dom';

import { ArrowRight } from 'lucide-react';

import { useOnboarding } from '../../hooks/useOnboarding';
import { Button } from '../common';

interface OnboardingPageWrapperProps {
	children: React.ReactNode;
	stepId: number;
	showArrowButton?: boolean;
	onStepComplete?: () => void;
	customProps?: Record<string, any>;
}

const OnboardingPageWrapper: React.FC<OnboardingPageWrapperProps> = ({
	children,
	stepId,
	showArrowButton = true,
	onStepComplete,
	customProps = {},
}) => {
	const navigate = useNavigate();
	const { completeStepById } = useOnboarding();

	const handleContinue = () => {
		completeStepById(stepId);

		if (onStepComplete) {
			onStepComplete();
		}

		navigate('/onboarding');
	};

	const handleBack = () => {
		navigate('/onboarding');
	};

	const handleOnboardingComplete = () => {
		completeStepById(stepId);
		navigate('/onboarding');
	};

	// Enhanced children with onboarding-specific props
	const enhancedChildren = React.Children.map(children, (child) => {
		if (React.isValidElement(child)) {
			return React.cloneElement(child, {
				...customProps,
				onBack: handleBack,
				onboardingMode: true,
				onNavigateToOnboarding: handleBack,
				onOnboardingComplete: handleOnboardingComplete,
				mfe: false,
				...child.props, // Preserve original props
			});
		}
		return child;
	});

	return (
		<div className="relative">
			{/* Render the wrapped component with enhanced props */}
			<div className="onboarding-content">{enhancedChildren}</div>

			{/* Floating Arrow Button - Vertically Centered Right */}
			{showArrowButton && (
				<div className="fixed right-8 top-1/2 transform -translate-y-1/2 z-10">
					<Button
						onClick={handleContinue}
						variant="primary"
						size="lg"
						className="rounded-full"
						icon={ArrowRight}
						title="Continue to Next Step"
					></Button>
				</div>
			)}
		</div>
	);
};

export default OnboardingPageWrapper;
